import React from 'react';

import { ReactProps } from '../../../typings/common-types';

import Icon, { IIcon } from './icon';

const svg = (props: ReactProps) => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Group">
      <circle id="Oval" cx="16" cy="16" r="15" fill="white" stroke="#FFBC00" strokeWidth="2" />
      <path
        id="Vector"
        d="M11.058 8.89478H20.7363C21.0588 8.89478 21.3206 9.1566 21.3206 9.47909V22.5214C21.3206 22.8437 21.059 23.1053 20.7367 23.1053H11.0575C10.7353 23.1053 10.4736 22.8437 10.4736 22.5214V9.47909C10.4736 9.1566 10.7355 8.89478 11.058 8.89478Z"
        fill="#FFBC00"
      />
    </g>
  </svg>
);

const IconYellowCardWithCircle = (props: IIcon & ReactProps) => <Icon {...props} svg={svg} />;

export default IconYellowCardWithCircle;
